import React from 'react';
import { Query, Mutation } from '@apollo/client/react/components';

import CurrentUserNotificationSettingsQuery from 'buyside/graphql/queries/CurrentUserNotificationSettings';
import UpdateNotificationSettingsMutation from 'buyside/graphql/mutations/UpdateNotificationSettings';

import LoadingSpinner, {
  SIZES
} from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';
import SiteNotificationSettings from 'buyside/components/presentation/UserAccount/SiteNotifications/siteNotificationSettings';

const defaultNotificationSettings = {
  showAll: false,
  showContests: true,
  showComments: true,
  showIdeas: true,
  showRankings: true,
  showBadges: true,
  showCapIntro: true,
  showFundFollower: true,
  showNewRecommended: true,
  showWatchlist: true,
  showWhitePapers: true,
  showFollowers: true,
  showFolloweeActivity: true,
  showJobVault: true,
  showTrendingResearch: false,
  showActivelyDiscussed: false,
  showBiggestMovers: false,
  showViewerIntroRequests: true
};

const SiteNotificationSettingsContainer = () => (
  <Query query={CurrentUserNotificationSettingsQuery}>
    {({ loading, error, data = {} }) => {
      return (
        <Mutation mutation={UpdateNotificationSettingsMutation}>
          {mutate => {
            const updateSiteNotificationSettings = args => mutate({ variables: args });
            const handleUpdateSiteNotificationSettings = (values, setSubmitting) =>
              updateSiteNotificationSettings(values).then(() => setSubmitting(false));
            if (loading) return <LoadingSpinner size={SIZES.LARGE} />;
            return (
              <SiteNotificationSettings
                error={error}
                currentUser={data.currentUser}
                initialValues={
                  data.currentUser && data.currentUser.userNotificationSetting
                    ? data.currentUser.userNotificationSetting
                    : defaultNotificationSettings
                }
                handleUpdateSiteNotificationSettings={handleUpdateSiteNotificationSettings}
              />
            );
          }}
        </Mutation>
      );
    }}
  </Query>
);

export default SiteNotificationSettingsContainer;
